













import { LanguageDto, UserDto } from "@/server/app.dtos";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class UserDetailDashboardPage extends Vue {
  @Prop() user!: UserDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
}
